import * as Sentry from "@sentry/nextjs";
import ErrorPage from "@/src/components/elements/Papers/ErrorPage";

interface MonitoringErrorBoundaryProps {
  children: React.ReactNode;
  componentName: string;
}

export function MonitoringErrorBoundary({
  children,
  componentName,
}: MonitoringErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <ErrorPage
          message="Terjadi Kesalahan"
          description="Maaf, terjadi kesalahan pada aplikasi. Silakan coba lagi."
          asset={`${process.env.CDN_URL}/images/main/mobile/halamannotfound-icon.webp`}
          url="/"
          actionWord="REFRESH"
        />
      }
      beforeCapture={(scope) => {
        scope.setTag("componentName", componentName);
        scope.setTag("source", "ui-error");
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
